import { ApiClientExtension } from '@vue-storefront/core';
import { XBUY_COOKIE_TOKEN, XBUY_COOKIE_DOMAIN } from './index';
// import {
//   VSF_LOCALE_COOKIE,
//   VSF_CURRENCY_COOKIE,
//   VSF_COUNTRY_COOKIE
// } from '@vue-storefront/core';

function createAuthIntegration(req, res) {
  // 从当前请求头中获取当前token
  const currentToken = req.cookies[XBUY_COOKIE_TOKEN];
  // console.warn('[2.1]----index.server.ts 当前token=', currentToken);

  return {
    setToken: (token) => {
      if (token) {
        // maxAge单位是毫秒
        res.cookie(XBUY_COOKIE_TOKEN, token, { maxAge: 24 * 60 * 60 * 24 * 30 * 1000, sameSite: 'lax' });
        // console.warn('[2.3]----index.server.ts -----登录完成,设置token=', token, res);
      }
    },
    getToken: () => {
      return currentToken;
    },
    removeToken: () => {
      res.clearCookie(XBUY_COOKIE_TOKEN);
    },
    getAllCookies: () => {
      return req.cookies;
    }
  };
}

// 编译cooke对象为字符串
function buildCookie(cookies) {
  let cookie = '';
  Object.keys(cookies).forEach(name => {
    const value = cookies[name];
    cookie += [name, '=', encodeURIComponent(value), '; '].join('');
  });
  return cookie;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const tokenExtension: ApiClientExtension = {
  name: 'tokenExtension',
  hooks: (req, res) => {
    // console.log('[2]----index.server.ts tokenExtension--hooks--------', req.cookies);
    const auth = createAuthIntegration(req, res);

    return {
      beforeCreate: ({ configuration }) => {
        // 从req中获取当前域名
        const domain = req.headers.host;
        if (!domain) {
          throw new Error('get_docmain_error');
        }

        // 在请求中自动注入domain
        req.cookies[XBUY_COOKIE_DOMAIN] = domain;
        res.cookie(XBUY_COOKIE_DOMAIN, domain, { maxAge: 24 * 60 * 60 * 24 * 30, sameSite: 'lax' });

        // 在axois的client注入全量cookies
        configuration.client.defaults.headers.cookie = buildCookie(req.cookies);
        // configuration.client.defaults.headers.cookie = encodeURIComponent(configuration.client.defaults.headers.cookie);
        // console.log('------beforeCreate------', req.cookies, configuration.client.defaults.headers.cookie);
        return {
          ...configuration,
          auth
        };
      },

      beforeCall: ({ callName, args, configuration }) => {
        if (configuration.api.api_debug) {
          console.log('------beforeCall------', callName, args, req.cookies);
        }
        // 如果是wishList接口,并且当前请求头中没有token,则不执行该接口
        if (configuration.api.need_token_apis.indexOf(callName) !== -1 && !req.cookies[XBUY_COOKIE_TOKEN]) {
          if (configuration.api.api_debug) {
            console.log('------beforeCall------无token不执行api:', callName);
          }

        } else {
          return args;
        }
      },

      afterCall: ({ callName, response, configuration, args }: any) => {
        if (configuration.api.api_debug) {
          console.log('------afterCall------', callName, args, response);
        }
        return response;
      }

    };
  }
};

